import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import GiftsHeader from "../../components/MyGifts/GiftsHeader";
import GiftsEmptyState from "../../components/MyGifts/GiftsEmptyState";
import GiftsGrid from "../../components/MyGifts/GiftsGrid";
import LoadingState from "../../components/Common/LoadingState";
import { getMyGifts } from "../../api/giftApi";
import { useAsyncAction } from "../../hooks/useAsyncAction";
import { showErrorToast } from "../../utils/toast";

const MyGifts = () => {
    const { t } = useTranslation();
    const [gifts, setGifts] = useState([]);
    const [totalValue, setTotalValue] = useState("€0.00");
    const loadAction = useAsyncAction();
    const { run: runLoadGifts } = loadAction;
    const isLoading = loadAction.isLoading;
    const apiError = loadAction.errorMessage;

    useEffect(() => {
        if (!apiError) return;
        showErrorToast(apiError);
    }, [apiError]);

    useEffect(() => {
        let mounted = true;

        const loadGifts = async () => {
            const result = await runLoadGifts(
                () => getMyGifts(),
                { errorFallback: t("MY_GIFTS_ERROR_LOAD"), silentErrorToast: true }
            );
            if (!mounted) return;
            setGifts(result?.gifts || []);
            setTotalValue(result?.totalValue || "€0.00");
        };

        loadGifts();
        return () => {
            mounted = false;
        };
    }, [runLoadGifts, t]);

    return (
        <Layout activeLabel="My gifts">
            <div>
                <GiftsHeader totalValue={totalValue} />

                {isLoading ? (
                    <LoadingState message={t("MY_GIFTS_LOADING")} />
                ) : gifts.length ? (
                    <GiftsGrid items={gifts} />
                ) : !isLoading && !gifts.length ? (
                    <GiftsEmptyState />
                ) : null}
            </div>
        </Layout>
    );
};

export default MyGifts;
